import { RECENT_WORK } from "@/data/site";
import { useReveal } from "@/hooks/useReveal";
import { SectionHeading } from "@/components/site/SectionHeading";

const WorkCard = ({ item, index }) => {
  const [ref, visible] = useReveal();
  return (
    <figure
      ref={ref}
      data-testid={`work-item-${index}`}
      style={{ transitionDelay: `${(index % 4) * 70}ms` }}
      className={`reveal ${visible ? "is-visible" : ""} group relative overflow-hidden border border-zinc-800 bg-zinc-950`}
    >
      {/* square container so rotated phone photos still fill cleanly */}
      <div className="relative w-full pt-[100%] overflow-hidden">
        <img
          src={item.src}
          alt={item.caption}
          loading="lazy"
          className={`absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105 ${
            item.rotate === "ccw"
              ? "-rotate-90"
              : item.rotate === "180"
              ? "rotate-180"
              : item.rotate
              ? "rotate-90"
              : ""
          }`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-200" />
      </div>

      <figcaption className="absolute inset-x-0 bottom-0 p-5 translate-y-2 group-hover:translate-y-0 transition-transform duration-200">
        <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-red-500">
          {item.category}
        </span>
        <p className="mt-1 font-heading text-xl md:text-2xl tracking-wide text-white">
          {item.caption}
        </p>
      </figcaption>
    </figure>
  );
};

export const RecentWork = () => {
  return (
    <section id="work" data-testid="recent-work-section" className="relative bg-zinc-950 py-24 md:py-32 border-y border-zinc-900">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <SectionHeading
          label="Proof In The Work"
          title="Recent Work"
          desc="Real projects, real results across East Tennessee. Precision in every detail, pride in every job."
        />
        <div className="mt-14 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {RECENT_WORK.map((item, i) => (
            <WorkCard key={item.src} item={item} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
